import {MobileSort} from './MobileSort/MobileSort';
import React from 'react';
import {DataHook} from '../../ExtendedGridGallery/ExtendedGridGallery';
import {MobileFilters} from './MobileFilters/MobileFilters';
import s from './MobileFiltersAndSort.scss';
import {ConditionalRender} from '../ConditionalRender/ConditionalRender';
import {useGlobals, withGlobals} from '../../../globalPropsContext';

const MobileFiltersAndSortComp = () => {
  const {hasFilters, hasActiveSortOption} = useGlobals();

  return (
    <div className={s.mobileFiltersAndSort} data-hook={DataHook.MobileContainer}>
      {hasFilters && (
        <ConditionalRender by="galleryShowFilters" className={s.mobileFiltersContainer}>
          <MobileFilters />
        </ConditionalRender>
      )}
      {hasActiveSortOption && (
        <ConditionalRender by="galleryShowSort" className={s.mobileSortContainer}>
          <MobileSort />
        </ConditionalRender>
      )}
    </div>
  );
};

export const MobileFiltersAndSort = withGlobals(MobileFiltersAndSortComp);
